import { render } from "./Directorio.vue?vue&type=template&id=fb558fe2&scoped=true"
import script from "./Directorio.vue?vue&type=script&lang=ts"
export * from "./Directorio.vue?vue&type=script&lang=ts"

import "./Directorio.vue?vue&type=style&index=0&id=fb558fe2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb558fe2"

export default script